export default [{
  path: '/painel-honorarios',
  name: 'painel-honorarios',
  component: () => import('./PainelHonorariosDashboard.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-honorarios',
    pageTitle: '',
  },
}, {
  path: '/painel-honorarios/contratos',
  name: 'painel-honorarios-contratos',
  redirect: { name: 'configuracaocobranca' },
}, {
  path: '/painel-honorarios/analise/:empresaId?',
  name: 'painel-honorarios-analise',
  component: () => import('./PainelHonorariosAnalise.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-honorarios',
    pageTitle: 'Análise de Reprecificação',
  },
}]
